import { TicketsStatusReference } from '@/types/codegen-federation'

/**
 * Checks if tickets are currently being sold for a theatrical release.
 * Returns true if the ticketStatus is 'PRE_SALES' or 'LIVE'.
 * @param ticketStatus - The ticket status from the theatrical release
 */
export const isSellingTickets = (ticketStatus?: TicketsStatusReference | null): boolean => {
  return ticketStatus === 'PRE_SALES' || ticketStatus === 'LIVE'
}
